import React, { Component } from "react";
import { connect } from "react-redux";
import { deleteItemFromList } from "../../../redux/actions/listActions";
import { hideModal } from "../../../redux/actions/modalActions";

interface Props {
  list_id: number;
  item_id: string | number;
  item_name: string;
  list_name?: string; // Add list name as an optional prop
  deleteItemFromList: (list_id: number, item_id: string | number) => Promise<any>;
  hideModal: any;
  onItemDeleted?: () => void;
  position?: { top: number, left: number }; // Position for the pointy arrow
}

interface State {}

class DeleteListItemModalContent extends Component<Props, State> {
  deleteListItem = async () => {
    try {
      await this.props.deleteItemFromList(this.props.list_id, this.props.item_id);
      
      // Call callback if provided (for list refresh)
      if (this.props.onItemDeleted) {
        this.props.onItemDeleted();
      }
      
      this.props.hideModal();
    } catch (error) {
      console.error("Error deleting list item:", error);
    }
  };
  
  render() {
    const { position, list_name } = this.props;
    const modalStyle = position ? {
      position: 'absolute' as const,
      top: `${position.top - 45}px`,  // Position in line with the X button
      left: `${position.left - 400}px`, // Position modal to the left of the X
      transform: 'none' as const,
      maxWidth: "400px",
      width: "350px", // Fixed width for consistency
      zIndex: 1001,
    } : {
      position: 'fixed' as const,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "90%",
      zIndex: 1001
    };
    
    return (
      <div className="o-modal__container">
        <div className="o-modal__backdrop" onClick={() => this.props.hideModal()}></div>
        <div 
          className="o-modal__content u-background--white u-br--small"
          style={modalStyle}
        >
          {position && (
            <div 
              style={{
                position: 'absolute',
                top: '50%',
                right: '-10px',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderTop: '10px solid transparent',
                borderBottom: '10px solid transparent',
                borderLeft: '10px solid white'
              }}
            />
          )}
          <div className="u-ph--32 u-pb--32 u-pt--24">
            <div className="u-color-magenta u-semi-bold u-main-font--small u-pb--8">
              Remove item from list
            </div>
            <div className="u-main-font--vsmall u-pb--16">
              Remove <span className="u-bold">"{this.props.item_name}"</span> from {list_name ? <span>the <span className="u-bold">"{list_name}"</span> list</span> : 'this list'}?
            </div>

            <button
              className="u-background--magenta u-br--small u-color-white u-p--8 u-ph--16 u-semi-bold u-main-font--vsmall"
              onClick={this.deleteListItem}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    );
  }
}

// Create the connected component with a proper export
const ConnectedDeleteListItemModalContent = connect(
  null,
  { deleteItemFromList, hideModal }
)(DeleteListItemModalContent);

// Export as default
export default ConnectedDeleteListItemModalContent;
